package nl.volleyplanner.web.base.component

import kotlinx.html.*
import kotlinx.html.js.onChangeFunction
import kotlinx.html.org.w3c.dom.events.Event
import nl.volleyplanner.web.IdGenerator

enum class CheckboxType {
    Checkbox,
    Radio,
    Switch,
    ToggleButton
}

/**
 * Build a Bootstrap Checkbox compoment
 * @param checkboxType Type of checkbox (regular checkbox, radio, switch or toggle button)
 * @param inline Make this an inline element (e.g. on the same row with other elements)
 * @param isEnabled If the checkbox can get modified or not
 * @param isChecked Default state of the checkbox
 * @param label Label to display with the checkbox
 * @param htmlId HTML ID, defaults to 'checkbox-$randomNumber'
 * @param htmlName HTML Name: In case you need this in a form. Not set by default
 * @param onChangeFunction Triggers on a JS onChange
 * @param toggleButtonCssClass For CheckboxType.ToggleButton only: the button class to use
 */
fun FlowContent.checkbox(
    checkboxType: CheckboxType = CheckboxType.Checkbox,
    inline: Boolean = false,
    isEnabled: Boolean = true,
    isChecked: Boolean = false,
    label: String? = null,
    htmlId: String = "checkbox-${IdGenerator.nextId()}",
    htmlName: String? = null,
    htmlValue: String? = null,
    onChangeFunction: ((Event) -> Unit)? = null,
    toggleButtonCssClass: String? = null,
    labelHtml: (LABEL.() -> Unit)? = null
) {
    fun FlowContent.checkboxInputElement() {
        input {
            if (checkboxType == CheckboxType.ToggleButton) {
                classes += "btn-check"
                autoComplete = "false"
            } else {
                classes += "form-check-input"
            }
            if (htmlName != null) {
                name = htmlName
            }
            type = when (checkboxType) {
                CheckboxType.Checkbox -> InputType.checkBox
                CheckboxType.Switch -> InputType.checkBox
                CheckboxType.Radio -> InputType.radio
                CheckboxType.ToggleButton -> InputType.checkBox
            }
            if (checkboxType == CheckboxType.Switch) {
                role = "switch"
            }
            id = htmlId
            checked = isChecked
            disabled = !isEnabled

            if (htmlValue != null) {
                value = htmlValue
            }

            if (onChangeFunction != null) {
                this.onChangeFunction = onChangeFunction
            }
        }
    }

    val requireWrapper = when {
        checkboxType == CheckboxType.ToggleButton -> false
        checkboxType == CheckboxType.Switch -> true
        label != null -> true
        else -> false
    }

    if (!requireWrapper) {
        checkboxInputElement()
    } else {
        div(classes = "form-check") {
            if (inline) {
                classes += "form-check-inline"
            }
            if (checkboxType == CheckboxType.Switch) {
                classes += "form-switch"
            }
            checkboxInputElement()
            if (label != null || labelHtml != null) {
                label {
                    if (checkboxType == CheckboxType.ToggleButton) {
                        classes += "btn"
                        classes += toggleButtonCssClass ?: "btn-primary"
                    } else {
                        classes += "form-check-label"
                    }

                    htmlFor = htmlId
                    if (label != null) {
                        +label
                    } else {
                        labelHtml!!()
                    }
                }
            }
        }
    }
}